import type { CmpCompetitor, CmpScanMeta, CmpStat } from './types';

/** Every tracked competitor in the clinic's market radius. */
export const CMP_COMPETITORS: CmpCompetitor[] = [
  {
    id: 'smile-central',
    name: 'Smile Central Dental',
    domain: 'smilecentraldental.com',
    address: '123 Main St, Brampton',
    distanceMiles: 0.8,
    threatScore: 82,
    rating: 4.8,
    reviews: 450,
    reviewVelocity: '+12/mo',
    activeAds: 12,
    topKeywords: ['Invisalign', 'Implants'],
    type: 'Corporate DSO',
    moat: 'Massive Review Lead',
    source: 'auto',
  },
  {
    id: 'bright-smiles',
    name: 'Bright Smiles Co.',
    domain: 'brightsmiles.com',
    address: '456 Queen St, Brampton',
    distanceMiles: 1.2,
    threatScore: 65,
    rating: 4.2,
    reviews: 128,
    reviewVelocity: '+3/mo',
    activeAds: 6,
    topKeywords: ['Cosmetic', 'Whitening'],
    type: 'Private',
    moat: 'Aggressive Bidder',
    source: 'auto',
  },
  {
    id: 'meadowvale',
    name: 'Meadowvale Dental Care',
    domain: 'meadowvaledental.ca',
    address: '789 Financial Dr, Mississauga',
    distanceMiles: 2.1,
    threatScore: 71,
    rating: 4.5,
    reviews: 312,
    reviewVelocity: '+8/mo',
    activeAds: 8,
    topKeywords: ['Family Dentist', 'Emergency'],
    type: 'Group Practice',
    moat: 'SEO Dominance',
    source: 'auto',
  },
  {
    id: 'churchville',
    name: 'Churchville Family Dentistry',
    domain: 'churchvilledental.com',
    address: '22 Churchville Rd, Brampton',
    distanceMiles: 3.4,
    threatScore: 38,
    rating: 3.9,
    reviews: 87,
    reviewVelocity: '+1/mo',
    activeAds: 2,
    topKeywords: ['General', 'Cleanings'],
    type: 'Solo Practice',
    moat: null,
    source: 'auto',
  },
  {
    id: 'hilton',
    name: 'Hilton Dental Care',
    domain: 'hiltondental.ca',
    address: '101 Hilton Blvd, Mississauga',
    distanceMiles: 4.8,
    threatScore: 55,
    rating: 4.0,
    reviews: 203,
    reviewVelocity: '+5/mo',
    activeAds: 4,
    topKeywords: ['Veneers', 'Sedation'],
    type: 'Private',
    moat: 'Weekend Hours',
    source: 'auto',
  },
  {
    id: 'derry-west',
    name: 'Derry West Dental',
    domain: 'derrywestdental.com',
    address: '330 Derry Rd W, Mississauga',
    distanceMiles: 5.2,
    threatScore: 48,
    rating: 4.3,
    reviews: 176,
    reviewVelocity: '+4/mo',
    activeAds: 3,
    topKeywords: ['Implants', 'Botox'],
    type: 'Private',
    moat: null,
    source: 'auto',
  },
  {
    id: 'britannia',
    name: 'Britannia Dental Centre',
    domain: 'britanniadental.ca',
    address: '45 Britannia Rd, Mississauga',
    distanceMiles: 6.1,
    threatScore: 33,
    rating: 4.1,
    reviews: 94,
    reviewVelocity: '+2/mo',
    activeAds: 1,
    topKeywords: ['Emergency', 'Walk-in'],
    type: 'Solo Practice',
    moat: null,
    source: 'manual',
  },
  {
    id: 'westdale',
    name: 'Westdale Smiles',
    domain: 'westdalesmiles.com',
    address: '88 Westdale Ave, Brampton',
    distanceMiles: 7.3,
    threatScore: 61,
    rating: 4.6,
    reviews: 267,
    reviewVelocity: '+7/mo',
    activeAds: 5,
    topKeywords: ['Invisalign', 'Pediatric'],
    type: 'Group Practice',
    moat: 'Strong Content',
    source: 'auto',
  },
];

/** KPI tiles shown above the competitor list. */
export const CMP_STATS: CmpStat[] = [
  { key: 'total', label: 'Total competitors', value: '8', delta: '+2 this month', tone: 'success' },
  { key: 'avg-threat', label: 'Avg threat score', value: '56', delta: '↑ 4 pts', tone: 'terra' },
  { key: 'closest', label: 'Closest competitor', value: '0.8 mi', delta: 'Smile Central', tone: 'neutral' },
  { key: 'most-ads', label: 'Most active ads', value: '12', delta: 'Smile Central Dental', tone: 'neutral' },
  { key: 'avg-rating', label: 'Avg review rating', value: '4.3', delta: 'vs yours: 4.6', tone: 'success' },
];

/** How the market radius is scanned. */
export const CMP_SCAN_META: CmpScanMeta = {
  radius: '20 km radius from your clinic',
  cadence: 'checked every 24 hours',
  footerNote:
    'ELVA checks all competitor websites every 24 hours and scans for new competitors every 7 days.',
};
